import React from "react";
import Table from "react-bootstrap/Table";
import EventsTableRowPast from "./EventsTableRowPast";

function EventsTablePast({ events }) {
  return (
    <Table responsive className="table table-striped mb-0">
      <thead style={{ background: "#f8f9fa" }}>
        <tr>
          <th
            className="text-center"
            style={{ color: "#495057", width: "10%" }}
          >
            Date
          </th>
          <th
            className="text-start"
            style={{ color: "#495057", textAlign: "left" }}
          >
            Name
          </th>
          {/* <th className='text-center' style={{color:'#495057', width:'10%'}}>
                        Game
                    </th> */}
          <th
            className="text-center"
            style={{ color: "#495057", width: "10%" }}
          >
            Course
          </th>
        </tr>
      </thead>
      <tbody>
        {events.map((event, index) => (
          <EventsTableRowPast key={index} event={event} />
        ))}
      </tbody>
    </Table>
  );
}

export default EventsTablePast;
